import Elements from "./elements"

class DirectDebit {
  constructor(element, form) {
    this.element = element
    this.form = form
    this.stripe = Stripe(window.stripeKey, { locale: 'pt' })
    this.elements = this.stripe.elements()
    this.iban = this.elements.create(
      'iban',
      { style: Elements.styles(), supportedCountries: ['SEPA'], placeholderCountry: 'PT' }
    )
    this.iban.mount(this.element)
    this.iban.addEventListener('change', this.onChange.bind(this))
    this.iban.addEventListener('focus', this.onFocus.bind(this))
    this.isValid = false
    this.isSepaValid = false
    this.bindExistingSepaDebits()
  }

  bindExistingSepaDebits() {
    const existingSepaDebits = this.form.querySelectorAll('.existing-sepa')
    existingSepaDebits.forEach((sepaDebit) => {
      sepaDebit.addEventListener('change', () => {
        this.isValid = true
        this.form.dispatchEvent(new CustomEvent('payment:valid'))
      })
    })
  }

  onChange(iban) {
    if (iban.complete) {
      this.form.dispatchEvent(new CustomEvent('payment:valid'))
      this.isValid = true
      this.isSepaValid = true
    } else if (iban.error) {
      this._triggerError(iban.error.message)
    } else {
      this._triggerError()
    }
  }

  onFocus() {
    const checkedSepaDebit = this.form.querySelector('.existing-sepa:checked')
    if (checkedSepaDebit) checkedSepaDebit.checked = false

    if (!this.isSepaValid) this.form.dispatchEvent(new CustomEvent('payment:invalid'))
  }

  process() {
    const existingSepaDebit = this.form.querySelector('.existing-sepa:checked')
    if (existingSepaDebit) {
      this._assignSubscription(existingSepaDebit.value)
    } else {
      fetch(this.element.dataset.url, {
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': this.token
        }
      }).then(response => {
        return response.json()
      }).then(data => {
        this._confirmSeptDebitSetup(data.secret)
      })
    }
  }

  _confirmSeptDebitSetup(secret) {
    const accountHolder = document.querySelector('#account_holder')
    const email = document.querySelector('#email')

    this.stripe.confirmSepaDebitSetup(
      secret,
      {
        payment_method: {
          sepa_debit: this.iban,
          billing_details: {
            name: accountHolder.value,
            email: email.value
          }
        }
      }
    ).then((result) => {
      this._assignSubscription(result.setupIntent.payment_method)
    })
  }

  _assignSubscription(nonce) {
    return fetch(this.form.action, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.token
      },
      body: JSON.stringify({ nonce: nonce })
    }).then(response => {
      return response.json()
    }).then(data => {
      if (data.success) {
        this._handleSubscription(data.subscription)
      } else {
        this.form.dispatchEvent(new CustomEvent('payment:error', { bubbles: true, detail: data.message }))
      }
    })
  }

  _handleSubscription(subscription) {
    const { latest_invoice } = subscription
    const { payment_intent } = latest_invoice

    if (payment_intent) {
      const { status } = payment_intent

      if (status === 'requires_action' || status === 'requires_payment_method') {
        this.form.dispatchEvent(new CustomEvent('payment:invalid', { detail: 'Não foi possível completar o pagamento, escolha outro método de pagamento.' }))
      } else {
        this._complete()
      }
    } else {
      this._complete()
    }
  }

  _complete() {
    return fetch(`${this.form.action}/complete`, {
      method: 'put',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': this.token
      }
    }).then(response => {
      return response.json()
    }).then(data => {
      window.location = data.location
    })
  }

  _triggerError(message = null) {
    this.form.dispatchEvent(new CustomEvent('payment:invalid', { detail: message }))
    this.isValid = false
    this.isSepaValid = false
  }

  get token() {
    return document.querySelector('meta[name=csrf-token]').content
  }

  get valid() {
    return this.isValid
  }

  get automatic() {
    return true
  }
}

export default DirectDebit